import { render, staticRenderFns } from "./TraduccionAudio.vue?vue&type=template&id=1a09866d&lang=pug&"
import script from "./TraduccionAudio.vue?vue&type=script&lang=js&"
export * from "./TraduccionAudio.vue?vue&type=script&lang=js&"
import style0 from "./TraduccionAudio.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports